module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAoCAYAAAAR87HlAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACTSURBVHgB7dXRDUAwAIThqwmMYAQr2MAGjGADNmADNjCCEYxgBExQJ+lDB7hKpP2Ti7cvoonCWrtyDZQRLLkzFHy8TyhLsA/X7vDkcOveuICyBPtwFwoeEvwZnEOZg/dfwZMUfg/LfdsBiuIE8xDgHic4QRWxjVugitgcJ7hBFbFR/Qvr4wQPK7xfMu7mKmPMBVEP08CDy3iZgAIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ui/templates-right-arrow.png
// module id = muUF
// module chunks = 1